module.exports = __webpack_public_path__ + "public/384d82b5a089ccfb4a2ac177e4e96147.woff2";